import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DIMMED_TEXT_VAR } from "./consultantPalette.js";
export function ChartLegend({ entries, className }) {
    // A legend with nothing in it is noise, not an empty state — the chart's own
    // empty/loading treatment is what a reader should see.
    if (entries.length === 0)
        return null;
    const cls = ["chart-legend", className ?? ""].filter(Boolean).join(" ");
    return (_jsx("ul", { className: cls, style: {
            display: "flex",
            flexWrap: "wrap",
            gap: "4px 14px",
            margin: 0,
            padding: 0,
            listStyle: "none",
        }, children: entries.map((entry, i) => (_jsxs("li", { className: `chart-legend__item${entry.dimmed ? " chart-legend__item--dimmed" : ""}`, style: {
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                font: "500 12px/1.5 var(--font-ui)",
                color: entry.dimmed ? DIMMED_TEXT_VAR : "var(--ard-text)",
            }, children: [_jsx("span", { className: "chart-legend__swatch", "aria-hidden": "true", style: {
                        width: "10px",
                        height: "10px",
                        borderRadius: "2px",
                        background: entry.colorVar,
                        flex: "0 0 auto",
                    } }), _jsx("span", { className: "chart-legend__label", children: entry.label })] }, `${i}:${entry.label}`))) }));
}
export default ChartLegend;
//# sourceMappingURL=ChartLegend.js.map